import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faQuestionCircle} from "@fortawesome/free-solid-svg-icons";
import {Trans, useTranslation} from "react-i18next";
import {LegacyRef, useState} from "react";
import {useClickAway} from "@uidotdev/usehooks";
import {Tooltip as ReactTooltip} from "react-tooltip";

const MinimalServiceFeeBanner = () => {

    const {t} = useTranslation();
    const [noteClicked, setNoteClicked] = useState<boolean>(false);
    const [noteHovered, setNoteHovered] = useState<boolean>(false);
    const tooltipId = 'minimal_service_fee_tooltip';

    const clickAwayRef = useClickAway(() => {
        setNoteClicked(false);
    }) as LegacyRef<any>;

    return (
        <>
            <div className="pricing-shopify-banner minimal-service-fee-banner">
                <p>
                    <b className="text-orange">{t('minimal_service_fee')}</b>
                    &nbsp;
                    <span className="cursor-pointer">
                        <FontAwesomeIcon icon={faQuestionCircle}
                                         data-tooltip-id={tooltipId}
                                         ref={clickAwayRef}
                                         onClick={() => setNoteClicked(!noteClicked)}
                                         onMouseEnter={() => setNoteHovered(true)}
                                         onMouseLeave={() => setNoteHovered(false)}/>
                    </span>
                </p>
                <ReactTooltip
                    id={tooltipId}
                    // @ts-ignore
                    content={<Trans>{t('minimal_service_fee_tooltip_text')}</Trans>}
                    isOpen={noteClicked || noteHovered}
                    place="top"
                    middlewares={[]}
                    style={{backgroundColor: '#f6f8fa', color: '#213f6f'}}
                />
                <p>
                    <Trans t={t} components={{textOrange: <span className='text-orange'/>}}>
                        {'minimal_service_fee_banner_text'}
                    </Trans>
                </p>
            </div>
        </>
    )
}

export default MinimalServiceFeeBanner;
